import Splide from '@splidejs/splide';
import '@splidejs/splide/css';

export const mainSlider = new Splide('#js-mainSlider', {
  type       : 'fade',
  pagination : false,
  arrows     : false,
  cover      : true,
  autoHeight : true,
});

export const thumbnailSlider = new Splide('#js-thumbnailSlider', {
  rewind          : true,
  fixedWidth      : 87,
  fixedHeight     : 87,
  isNavigation    : true,
  gap             : 15,
  focus           : 'left',
  pagination      : false,
  cover           : true,
  arrows          : false,
  dragMinThreshold: {
    mouse: 1,
  },
  breakpoints: {
    992: {
      fixedWidth  : 70,
      fixedHeight : 70,
    }
  }
});